import { Component, OnInit } from '@angular/core';
import { ChurchService } from '../../../services/church/church.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-iglesias',
  templateUrl: './iglesias.component.html',
  styleUrls: ['./iglesias.component.css']
})
export class IglesiasComponent implements OnInit {
  constructor(private _iglesiasService:ChurchService,
              private router: Router) { }

  ngOnInit() {
    this._iglesiasService.terminoBuscar = '';
  }

  searchIglesia()
  {
    console.log(this._iglesiasService.terminoBuscar);
    
    if(this._iglesiasService.terminoBuscar == '')
    {
      return;
    }
    this.router.navigate(['/admin','iglesias','buscar-iglesia']);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/iglesias/iglesias.component.ts